import * as React from 'react';

import {gaLegacyCustomEvent} from '../../../client/ga/ga-legacy.functions';
import {ImpUrl} from '../../../client/imp-url/imp-url.class';
import {SearchResult} from '../search.types';
import {User} from '../../users/user.class';
import {Select} from '../../ui/forms/Select/Select';

interface SortDropdownProps {
    resultList?: SearchResult;
    user: User;
}

export const SortDropdown = ({resultList, user}: SortDropdownProps) => (
    <>
        <Select
            aria-label="Sort By"
            className="!tw-mb-0 !tw-w-full"
            defaultValue={resultList.sortBy || 'relevancy'}
            id="browseSortDropdown"
            label=""
            name="sortDropdown"
            onChange={(changeEvent) => {
                const newValue = changeEvent.target.value;
                // Record sort GA
                let dropdownName: `Browse` | `Campaign Landing Page` | `Legacy Search Results Page` = `Browse`;
                if (resultList.layout === `campaign`) {
                    gaLegacyCustomEvent({eventAction: `Sort By`, eventCategory: `Campaign Landing Page`, eventLabel: newValue});
                }
                switch (resultList.layout) {
                    case `campaign`:
                        dropdownName = `Campaign Landing Page`;
                        break;
                    case `search`:
                        dropdownName = `Legacy Search Results Page`;
                        break;
                }
                gaLegacyCustomEvent({eventAction: `Sort By`, eventCategory: dropdownName, eventLabel: newValue});

                // Navigate to sort URL
                location.assign(ImpUrl.addParam(`sortBy`, newValue));
            }}
            options={[
                {key: 'relevancy', value: 'Relevancy', show: !!resultList.SearchString},
                {key: 'popularity', value: 'Popularity'},
                {key: 'brand_a', value: 'Brand A-Z'},
                {key: 'brand_z', value: 'Brand Z-A'},
                {key: 'price_0', value: 'Price Low to High', show: !!user.sortField},
                {key: 'price_9', value: 'Price High to Low', show: !!user.sortField},
                {key: 'desc_a', value: 'Description A-Z'},
                {key: 'desc_z', value: 'Description Z-A'},
                {key: 'item_0', value: 'Item 0-9'},
                {key: 'item_9', value: 'Item 9-0'},
                {key: 'newest', value: 'Newest to Oldest'},
                {key: 'oldest', value: 'Oldest To Newest'},
            ]}
            selectClasses="!tw-h-[38px] !tw-pt-2"
        />
    </>
);
